module.exports = __webpack_public_path__ + "static/media/cal_title.35b28163.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cal_title.png
// module id = 1625
// module chunks = 1